import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useUserStore } from '@/store/userStore';
import { hasRefreshSessionHint } from '@/helpers/authSession';
import { clearLocalSession } from '@/store/services/userServices';
import { refreshAccessToken } from '@/store/tokenRefresh';
import { LOGOUT_USER } from '@/store/actions/actionTypes';

//TODO remove LOGOUT_USER once redux removed from all entries
const useSilentRefresh = () => {
  const dispatch = useDispatch();
  const [isAuthReady, setIsAuthReady] = useState(() => !hasRefreshSessionHint());

  useEffect(() => {
    if (!hasRefreshSessionHint()) {
      useUserStore.getState().clearTokens();
      dispatch({ type: LOGOUT_USER });
      setIsAuthReady(true);
      return;
    }

    refreshAccessToken()
      .catch(() => {
        clearLocalSession({ redirect: false });
      })
      .finally(() => {
        setIsAuthReady(true);
      });
  }, [dispatch]);

  return { isAuthReady };
};

export default useSilentRefresh;
